<template>
    <transition
        enter-active-class="transition-opacity duration-300 ease-linear"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300 ease-linear"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-show="isShowing" class="relative z-40 flex justify-center">
            <div class="fixed inset-0 z-30 backdrop-blur" @click="closeModal">
                <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
            </div>

            <div
                class="fixed top-0 left-1/2 -translate-x-1/2 z-50 w-full max-w-3xl px-6 my-8 md:px-0"
                role="dialog"
            >
                <button
                    @click="closeModal"
                    class="absolute top-0 flex items-center justify-center w-8 h-8 p-4 -mt-4 -mr-4 text-white rounded-full right-6 md:right-0 bg-brand-blue"
                    type="button"
                >
                    <i class="fa fa-times"></i>
                </button>
                <div class="w-full max-h-[calc(100vh-64px)] p-8 overflow-y-auto bg-white rounded-lg shadow-xl">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: null,
        },
        queryParameter: {
            type: String,
            default: null,
        }
    },

    data: () => ({
        isShowing: false,
    }),

    methods: {
        /**
         * Set the modal to show.
         */
        showModal() {
            this.isShowing = true;
            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.classList.add("overflow-hidden");
            document.body.style.marginRight = scrollbarWidth + 'px';
            this.$emit('showing');
        },

        /**
         * Set the modal to hide.
         */
        closeModal() {
            this.isShowing = false;
            // remove classes after modal has animated away
            setTimeout(() => {
                document.body.classList.remove("overflow-hidden");
                document.body.style.marginRight = '0px';
            }, 300);
            this.$emit('closing');
        },
    },

    watch: {
        show(newValue) {
            if (newValue) {
                this.showModal();
            } else {
                this.closeModal();
            }
        }
    },

    mounted() {
        if (this.show === null) {
            this.$event.$on('modal:show', this.showModal);
            this.$event.$on('modal:close', this.closeModal);
        }

        if (this.queryParameter !== null) {
            const query = new URLSearchParams(location.search);

            if (['1', 'true'].includes(query.get(this.queryParameter))) {
                this.showModal();
            }
        }
    },
};
</script>
